import React from 'react';
import { animated, useSpring, interpolate } from 'react-spring';
import css from './InteractiveList.module.css';

interface Props {
    text: string;
    name: string;
    col: string[];
}

export const InteractiveList: React.FC<Props> = ({
    text,
    name,
    col,
}: {
    text: string;
    name: string;
    col: string[];
}) => {
    const [{ y, color, x, op }, set] = useSpring(() => ({
        y: 0,
        col: ['#acc9be', '#acc9be'],
        x: 5,
        op: 1,
    }));
    return (
        <li
            className={`${css.wrapper} ${name}`}
            onMouseEnter={() => set({ y: -30, color: col[0], x: 0, op: 0 })}
            onMouseLeave={() => set({ y: 0, color: col[1], x: 8, op: 1 })}
        >
            <animated.span
                style={{
                    transform: interpolate([y], (y) => `translateY(${y}px)`),
                    opacity: op,
                    color: color,
                }}
                className={name}
            >
                {text}
            </animated.span>
            <animated.span
                style={{
                    transform: interpolate([x, y], (x, y) => `translateY(${y}px) rotate(${x}deg)`),
                    color: color,
                }}
                className={name}
            >
                {text}
            </animated.span>
        </li>
    );
};
